export default {"src":"https://static.spiritory.com/_next/static/media/3.b61131db.svg","height":192,"width":148,"blurWidth":0,"blurHeight":0};